import { __decorate, __metadata } from "tslib";
import { Serialize, Type } from '@ftr/serialization';
import { ZonedDateTime } from '@js-joda/core';
import { Money } from '../../type/order';
import { ChargeAuthorization } from './ChargeAuthorization';
export class Charge {
    /**
     * @param id Identifies the charge
     * @param courtSystemId Which court system the charge was made in
     * @param status Current status of the charge
     * @param description The original description that was attached to the charge
     * @param statementDescription The original statement description that was attached to the charge
     * @param authorizations A record of all current and historic authorizations for this charge
     * @param settlementAmount The amount that was settled (if any) for this charge. Will be empty for charges that aren't
     * settled.
     * @param settledOn When settlement of this charge occurred, if ever
     * @param authorizedAmount The amount that was authorized (if any) for this charge. Will be empty for charges that are
     * settled immediately without authorization.
     */
    constructor(id, courtSystemId, status, description, statementDescription, authorizations, settlementAmount, settledOn, authorizedAmount) {
        this.id = id;
        this.courtSystemId = courtSystemId;
        this.status = status;
        this.description = description;
        this.statementDescription = statementDescription;
        this.authorizations = authorizations;
        this.settlementAmount = settlementAmount;
        this.settledOn = settledOn;
        this.authorizedAmount = authorizedAmount;
    }
}
__decorate([
    Type(() => ChargeAuthorization),
    __metadata("design:type", Array)
], Charge.prototype, "authorizations", void 0);
__decorate([
    Type(() => Money),
    __metadata("design:type", Object)
], Charge.prototype, "settlementAmount", void 0);
__decorate([
    Serialize(() => ZonedDateTime),
    __metadata("design:type", Object)
], Charge.prototype, "settledOn", void 0);
__decorate([
    Type(() => Money),
    __metadata("design:type", Object)
], Charge.prototype, "authorizedAmount", void 0);
